import { Component } from '@angular/core';
import * as XLSX from 'xlsx';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { UserService } from '../../layout/service/user.service';
import { CommonModule, DatePipe } from '@angular/common';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { Table } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { PasswordModule } from 'primeng/password';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
    selector: 'app-user',
    imports: [
        TableModule,
        TagModule,
        CommonModule,
        DatePipe,
        InputIconModule,
        InputTextModule,
        IconFieldModule,
        ButtonModule,
        DialogModule,
        PasswordModule,
        FormsModule,
        SelectModule,
        ToastModule,
        CheckboxModule,
        ConfirmDialogModule,
        QRCodeComponent,
    ],
    providers:[MessageService, ConfirmationService],
    template: `
        <p-toast />
        <p-confirmdialog />
        <div class="card">
            <div class="flex justify-between items-center mb-4">
                <h3 class="text-primary">Manajemen Pengguna</h3>
                <div class="flex gap-2 items-center">
                    <p-button severity="success" label="Tambah Pengguna" (click)="addUser()" icon="pi pi-plus"></p-button>
                    <p-button severity="info" label="Download Template" (click)="downloadExcelTemplate()" icon="pi pi-download"></p-button>
                    <p-button severity="warning" label="Upload Excel" (click)="fileInput.click()" icon="pi pi-upload"></p-button>
                    <input #fileInput type="file" accept=".xlsx,.xls" style="display:none" (change)="onExcelFileSelected($event)" />
                </div>
            </div>

            <!-- Access Roles Information -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div *ngFor="let role of accessRoles" class="p-4 border border-gray-200 rounded-lg bg-gray-50">
                    <div class="flex items-center justify-between mb-2">
                        <h4 class="font-bold text-lg text-blue-700">{{ role.NAME_ACCESS_ROLE }}</h4>
                        <p-tag [value]="getUserCountByRole(role.ID_ACCESS_ROLE)" severity="info"></p-tag>
                    </div>
                    <div class="text-sm text-gray-600 mb-2">
                        <strong>ID:</strong> {{ role.ID_ACCESS_ROLE }}
                    </div>
                    <div class="text-sm text-gray-600 mb-2" *ngIf="role.NOTED">
                        <strong>Catatan:</strong> {{ role.NOTED }}
                    </div>
                    <div class="text-xs text-gray-500">
                        <div>Dibuat: {{ role.CREATED_AT | date:'short' }} oleh {{ role.CREATED_BY }}</div>
                        <div *ngIf="role.UPDATED_AT">Diperbarui: {{ role.UPDATED_AT | date:'short' }} oleh {{ role.UPDATED_BY }}</div>
                    </div>
                </div>
            </div>

            <!-- Filter by Role -->
            <div class="flex justify-between items-center mb-4">
                <div class="flex gap-2 items-center">
                    <label class="font-semibold">Filter berdasarkan Peran:</label>
                    <p-select
                        [options]="roleFilterOptions"
                        [(ngModel)]="selectedRoleFilter"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Semua Peran"
                        (onChange)="filterByRole()"
                        class="w-48">
                    </p-select>
                </div>
                <div>
                    <p-iconField iconPosition="left">
                        <p-inputIcon>
                            <i class="pi pi-search"></i>
                        </p-inputIcon>
                        <input pInputText type="text" (input)="onInput($event, dt)" placeholder="Cari kata kunci" />
                    </p-iconField>
                </div>
            </div>

            <p-table #dt [value]="filteredUsers" stripedRows [tableStyle]="{ 'min-width': '50rem' }" [rowHover]="true" [rows]="10"
                [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [loading]="loading"
                [paginator]="true" currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} entri"
                [filterDelay]="0" [globalFilterFields]="['FULLNAME', 'USERNAME', 'NAME_ACCESS_ROLE']">

                <ng-template #header>
                    <tr>
                        <th>Nama</th>
                        <th>Username</th>
                        <th>Peran</th>
                        <th>Stasiun</th>
                        <th>Status</th>
                        <th>Aksi</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-user>
                    <tr>
                        <td>{{ user.FULLNAME }}</td>
                        <td>{{ user.USERNAME }}</td>
                        <td>
                            <p-tag [value]="user.NAME_ACCESS_ROLE"
                                   [severity]="getRoleSeverity(user.NAME_ACCESS_ROLE)"></p-tag>
                        </td>
                        <td>
                            <span *ngFor="let stasiun of user.LIST_STASIUN" class="mr-2">
                                <p-tag [value]="stasiun.NAME_STASIUN" severity="info" class="mb-2"></p-tag>
                            </span>
                        </td>
                        <td>
                            <p-tag
                                [value]="user.IS_ACTIVED == 1 ? 'Aktif' : 'Tidak Aktif'"
                                [severity]="user.IS_ACTIVED == 1 ? 'success' : 'danger'">
                            </p-tag>
                        </td>
                        <td>
                            <p-button icon="pi pi-qrcode" variant="text" [raised]="true" severity="primary" class="mr-2" (click)="openDialog('qrcode', user)"></p-button>
                            <p-button icon="pi pi-pencil" variant="text" [raised]="true" severity="warn" class="mr-2" (click)="openDialog('edit', user)"></p-button>
                            <p-button icon="pi pi-trash" variant="text" [raised]="true" severity="danger" class="mr-2" (click)="removeUser($event,user)"></p-button>
                            <p-button icon="pi pi-plus" variant="text" [raised]="true" severity="success" (click)="openDialog('section', user)"></p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <p-dialog
            [header]="dialogAction === 'edit' ? 'Edit Pengguna' : 'Tambah Pengguna'"
            [(visible)]="userDialog"
            [modal]="true"
            [style]="{ width: '35rem' }"
            position="top"
            draggable="false">
            <span class="text-surface-500 dark:text-surface-400 block mb-8">
                {{ dialogAction === 'edit' ? 'Perbarui informasi pengguna.' : 'Tambah pengguna baru.' }}
            </span>
            <div class="flex flex-col gap-2 mb-4">
                <label for="fullname" class="font-semibold w-24">Nama Lengkap</label>
                <input pInputText [(ngModel)]="fullname" id="fullname" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label for="username" class="font-semibold w-24">Username</label>
                <input pInputText [(ngModel)]="username" id="username" class="flex-auto" autocomplete="off" />
            </div>
            <div class="gap-4 mb-4 w-full" style="margin-right: 0 !important">
                <label for="password" class="font-semibold w-24 mb-4">Kata Sandi</label>
                <p-password
                    [(ngModel)]="password"
                    [toggleMask]="true"
                    [feedback]="false"
                    styleClass="w-full mt-2"
                    inputStyleClass="w-full"
                />
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label for="accessRole" class="font-semibold w-24">Peran Akses</label>
                <p-select
                    [options]="accessRoles"
                    appendTo="body"
                    [(ngModel)]="selectedAccess"
                    optionLabel="NAME_ACCESS_ROLE"
                    placeholder="Pilih peran akses"
                    class="w-full" />
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label for="status" class="font-semibold w-24">Status</label>
                <p-select
                    [options]="statusOptions"
                    appendTo="body"
                    [(ngModel)]="isActived"
                    optionLabel="label"
                    placeholder="Pilih status"
                    class="w-full">
                </p-select>
            </div>
            <ng-template #footer>
                <p-button label="Batal" [text]="true" severity="secondary" (click)="userDialog = false" />
                <p-button
                    [label]="dialogAction === 'edit' ? 'Perbarui' : 'Simpan'"
                    [outlined]="true"
                    severity="secondary"
                    (click)="saveUser()" />
            </ng-template>
        </p-dialog>

        <p-dialog
            header="Tambah Stasiun"
            [(visible)]="sectionDialog"
            [modal]="true"
            [style]="{ width: '35rem' }"
            position="top"
            draggable="false">
            <span class="text-surface-500 dark:text-surface-400 block mb-8">
                Tambahkan stasiun ke pengguna
            </span>
            <div class="grid grid-cols-3 gap-4">
                <div *ngFor="let section of sections" class="flex items-center mb-2">
                    <p-checkbox
                        [inputId]="'section-' + section.ID"
                        [value]="section.ID"
                        [(ngModel)]="selectedSections">
                    </p-checkbox>
                    <label [for]="'section-' + section.ID" class="ml-2"> {{ section.NAME_STASIUN }} </label>
                </div>
            </div>
            <ng-template #footer>
                <p-button label="Batal" [text]="true" severity="secondary" (click)="sectionDialog = false" />
                <p-button label="Simpan" [outlined]="true" severity="secondary" (click)="saveSections()" />
            </ng-template>
        </p-dialog>

        <!-- QR Code Dialog -->
        <p-dialog
            header="QR Code Pengguna"
            [(visible)]="qrcodeDialog"
            [modal]="true"
            [style]="{ width: '350px' }"
            position="top"
            draggable="false">
            <div class="flex flex-col items-center justify-center py-8">
                <qrcode
                    #qrcodeRef
                    [qrdata]="qrcodeValue"
                    [width]="256"
                    [errorCorrectionLevel]="'M'">
                </qrcode>
                <div class="mt-4 text-center">
                    <div class="font-bold">{{ qrcodeUser?.FULLNAME }}</div>
                    <div class="text-gray-500">{{ qrcodeUser?.USERNAME }}</div>
                    <div class="text-sm text-blue-600 mt-2" *ngIf="selectedSimulationPackage">
                        Simulasi: {{ selectedSimulationPackage.name }}
                    </div>
                </div>
                <button pButton type="button" label="Download QR" icon="pi pi-download" class="mt-4" (click)="downloadQrCode(qrcodeRef)"></button>
            </div>
            <ng-template #footer>
                <p-button label="Tutup" [text]="true" severity="secondary" (click)="qrcodeDialog = false" />
            </ng-template>
        </p-dialog>

        <!-- Simulation Package Selection Dialog -->
        <p-dialog
            header="Pilih Paket Simulasi"
            [(visible)]="simulationPackageDialog"
            [modal]="true"
            [style]="{ width: '600px' }"
            position="top"
            draggable="false">
            <div class="flex flex-col gap-4">
                <div class="text-gray-600 mb-4">
                    Pilih paket simulasi untuk QR Code pengguna <strong>{{ qrcodeUser?.FULLNAME }}</strong>
                </div>
                <div class="flex flex-col gap-2">
                    <label for="simulationPackage" class="font-semibold">Paket Simulasi</label>
                    <p-select
                        [options]="simulationPackages"
                        appendTo="body"
                        [(ngModel)]="selectedSimulationPackage"
                        optionLabel="name"
                        placeholder="Pilih paket simulasi"
                        class="w-full">
                        <ng-template pTemplate="selectedItem" let-item>
                            <div *ngIf="item">
                                <div class="font-semibold">{{ item.name }}</div>
                                <div class="text-sm text-gray-500">Kode: {{ item.code }}</div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="item" let-item>
                            <div class="p-2">
                                <div class="font-semibold">{{ item.name }}</div>
                                <div class="text-sm text-gray-500">Kode: {{ item.code }}</div>
                                <div class="text-xs text-gray-400" *ngIf="item.description" [innerHTML]="item.description"></div>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
            </div>
            <ng-template #footer>
                <p-button label="Batal" [text]="true" severity="secondary" (click)="simulationPackageDialog = false" />
                <p-button
                    label="Generate QR"
                    [outlined]="true"
                    severity="primary"
                    (click)="generateQRWithSimulation()"
                    [disabled]="!selectedSimulationPackage" />
            </ng-template>
        </p-dialog>

        <!-- Upload Progress Dialog -->
        <p-dialog header="Sedang Mengupload..." [(visible)]="uploadProgressDialog" [modal]="true" [closable]="false" [style]="{ width: '480px' }" position="top" draggable="false">
            <div class="flex flex-col gap-4 py-4">
                <div class="text-center text-2xl font-bold text-blue-700">{{ uploadCurrent }} / {{ uploadTotal }}</div>
                <div class="w-full bg-gray-200 rounded-full h-5 overflow-hidden">
                    <div class="bg-blue-600 h-5 rounded-full transition-all duration-300" [style.width]="uploadPercent + '%'"></div>
                </div>
                <div class="flex justify-between text-sm font-semibold px-1">
                    <span class="text-green-600">✓ Berhasil: {{ uploadSuccess }}</span>
                    <span class="text-blue-500">{{ uploadPercent }}%</span>
                    <span class="text-red-500">✗ Gagal: {{ uploadFailed }}</span>
                </div>
                <div class="text-center text-gray-400 text-sm">Sedang memproses data, harap tunggu...</div>
            </div>
        </p-dialog>

        <!-- Upload Summary Dialog -->
        <p-dialog header="Ringkasan Upload Excel" [(visible)]="uploadSummaryDialog" [modal]="true" [style]="{ width: '620px' }" position="top" draggable="false">
            <div class="flex flex-col gap-4 py-2">
                <div class="grid grid-cols-3 gap-3 text-center mb-2">
                    <div class="p-3 bg-blue-50 rounded-xl border border-blue-200">
                        <div class="text-2xl font-bold text-blue-700">{{ uploadTotal }}</div>
                        <div class="text-xs text-gray-500 mt-1">Total Data</div>
                    </div>
                    <div class="p-3 bg-green-50 rounded-xl border border-green-200">
                        <div class="text-2xl font-bold text-green-700">{{ uploadSuccess }}</div>
                        <div class="text-xs text-gray-500 mt-1">Berhasil</div>
                    </div>
                    <div class="p-3 bg-red-50 rounded-xl border border-red-200">
                        <div class="text-2xl font-bold text-red-700">{{ uploadFailed }}</div>
                        <div class="text-xs text-gray-500 mt-1">Gagal</div>
                    </div>
                </div>
                <p-table [value]="uploadResults" [scrollable]="true" scrollHeight="280px">
                    <ng-template #header>
                        <tr>
                            <th style="width:60px">Baris</th>
                            <th>Username</th>
                            <th style="width:100px">Status</th>
                            <th>Keterangan</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-r>
                        <tr>
                            <td>{{ r.row }}</td>
                            <td>{{ r.username }}</td>
                            <td><p-tag [value]="r.status" [severity]="r.status === 'Berhasil' ? 'success' : 'danger'"></p-tag></td>
                            <td class="text-sm text-gray-500">{{ r.error || '-' }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <ng-template #footer>
                <p-button label="Tutup & Refresh" icon="pi pi-refresh" severity="primary" (click)="closeSummaryAndRefresh()" />
            </ng-template>
        </p-dialog>
    `,
    standalone: true
})
export class User {
    constructor(
        private userService: UserService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService
    ) {}

    users           : any[]     = [];
    accessRoles     : any[]     = [];
    sections        : any[]     = [];
    loading         : boolean   = true;
    userDialog      : boolean   = false;
    sectionDialog   : boolean   = false;
    searchValue     : string    = '';
    password        : string    = '';
    username        : string    = '';
    fullname        : string    = '';
    id_access_role  : string    = '';
    selectedAccess  : any    = {};
    dialogAction    : 'add' | 'edit' | 'section' | 'qrcode' = 'add';
    isActived       : any    = {};
    statusOptions   = [
        { label: 'Active', value: 1 },
        { label: 'Inactive', value: 0 }
    ];
    currentUser     : any    = {};
    selectedSections: any[] = [];
    qrcodeDialog: boolean = false;
    qrcodeValue: string = '';
    qrcodeUser: any = null;
    qrcodeSecret: string = 'secret-key-123'; // Ganti dengan secret key yang aman

    // New properties for simulation packages
    simulationPackages: any[] = [];
    selectedSimulationPackage: any = null;
    simulationPackageDialog: boolean = false;

    // New properties for role filtering
    filteredUsers: any[] = [];
    selectedRoleFilter: string = '';
    roleFilterOptions: any[] = [];

    // Excel bulk upload
    uploadProgressDialog: boolean = false;
    uploadSummaryDialog: boolean = false;
    uploadTotal: number = 0;
    uploadCurrent: number = 0;
    uploadSuccess: number = 0;
    uploadFailed: number = 0;
    uploadProcessing: boolean = false;
    uploadResults: { row: number; username: string; status: string; error?: string }[] = [];
    get uploadPercent(): number {
        return this.uploadTotal > 0 ? Math.round((this.uploadCurrent / this.uploadTotal) * 100) : 0;
    }

    ngOnInit() {
        this.userService.getUsers().then((response) => {
            this.users = response.data;
            this.users.forEach(user => {
                if (typeof user.LIST_STASIUN === 'string') {
                    user.LIST_STASIUN = JSON.parse(user.LIST_STASIUN);
                }
            });
            this.filteredUsers = [...this.users];
            this.loading = false;
        }).catch(() => {
            console.error('error');
            this.loading = false;
        });

        this.userService.getAccessRoles().then((response) => {
            this.accessRoles = response.data;
            this.setupRoleFilterOptions();
        })

        const userData = localStorage.getItem('user');
        this.currentUser = userData ? JSON.parse(userData) : null;

        const userId = this.currentUser?.ID_USER ?? this.currentUser?.ID ?? this.currentUser?.id ?? '';

        this.userService.getSections(userId).then((response) => {
            this.sections = response.data;
        })
    }

    onInput(event: Event, dt: Table) {
        const inputElement = event.target as HTMLInputElement;
        dt.filterGlobal(inputElement.value, 'contains');
    }

    clear(table: Table) {
        table.clear();
        this.searchValue = ''
    }

    openDialog(action: 'edit' | 'add' | 'section' | 'qrcode', user: any = null) {
        this.dialogAction = action;

        if (action === 'edit' && user) {
            this.userDialog = true;
            this.username = user.USERNAME;
            this.fullname = user.FULLNAME;
            this.password = '';
            this.selectedAccess = this.accessRoles.find(role => role.ID_ACCESS_ROLE === user.ID_ACCESS_ROLE);
            this.isActived = this.statusOptions.find(status => status.value == user.IS_ACTIVED);

        } else if (action === 'add') {
            this.username = '';
            this.fullname = '';
            this.password = '';
            this.selectedAccess = {};
            this.isActived = {};
            this.userDialog = true;
        } else if (action === 'section') {
            this.username = user.USERNAME;
            this.sectionDialog = true;
            this.selectedSections = user.LIST_STASIUN?.map((stasiun: any) => stasiun.ID) || []; // Pre-select user's current section IDs
        } else if (action === 'qrcode' && user) {
            this.qrcodeUser = user;
            this.loadSimulationPackages();
            this.simulationPackageDialog = true;
        }
    }

    // Load simulation packages for QR code generation
    loadSimulationPackages() {
        this.userService.getPackageSimulation().then((response) => {
            this.simulationPackages = response.data || [];
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load simulation packages' });
        });
    }

    // Generate QR code with simulation package
    generateQRWithSimulation() {
        if (!this.selectedSimulationPackage) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select a simulation package' });
            return;
        }

        // Generate QR code containing simulation code + user token
        const qrData = {
            simulationCode: this.selectedSimulationPackage.code,
            userToken: `${this.qrcodeUser.USERNAME}_${Date.now()}`,
            userId: this.qrcodeUser.ID_USER,
            userName: this.qrcodeUser.FULLNAME
        };

        this.qrcodeValue = JSON.stringify(qrData);
        this.simulationPackageDialog = false;
        this.qrcodeDialog = true;
    }

    // Fungsi download QR code
    downloadQrCode(qrcodeRef: any) {
        // Cari elemen canvas dari qrcodeRef
        const canvas: HTMLCanvasElement | null = qrcodeRef?.qrcElement?.nativeElement?.querySelector('canvas');
        if (!canvas) return;
        const url = canvas.toDataURL('image/png');
        const a = document.createElement('a');
        a.href = url;
        a.download = `qrcode_${this.qrcodeUser?.USERNAME || 'user'}.png`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    // Setup role filter options
    setupRoleFilterOptions() {
        this.roleFilterOptions = [
            { label: 'Semua Peran', value: '' },
            ...this.accessRoles.map(role => ({
                label: role.NAME_ACCESS_ROLE,
                value: role.ID_ACCESS_ROLE
            }))
        ];
    }

    // Filter users by role
    filterByRole() {
        if (!this.selectedRoleFilter) {
            this.filteredUsers = [...this.users];
        } else {
            this.filteredUsers = this.users.filter(user =>
                user.ID_ACCESS_ROLE === this.selectedRoleFilter
            );
        }
    }

    // Get user count by role
    getUserCountByRole(roleId: string): number {
        return this.users.filter(user => user.ID_ACCESS_ROLE === roleId).length;
    }

    // Get role severity for styling
    getRoleSeverity(roleName: string): string {
        switch (roleName?.toLowerCase()) {
            case 'admin':
            case 'admin full access':
                return 'danger';
            case 'tutor':
                return 'warning';
            case 'peserta':
                return 'info';
            default:
                return 'secondary';
        }
    }

    saveUser() {
        if (this.dialogAction === 'edit') {
            this.userService.editUser({
                USERNAME: this.username,
                FULLNAME: this.fullname,
                PASSWORD: this.password,
                ID_ACCESS_ROLE: this.selectedAccess.ID_ACCESS_ROLE,
                IS_ACTIVED: this.isActived.value,
                UPDATED_BY: this.currentUser.USERNAME
            }).then(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User updated successfully' });
                this.ngOnInit();
            }).catch(() => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update user' });
            })
        } else {
            this.userService.registerUser({
                USERNAME: this.username,
                FULLNAME: this.fullname,
                PASSWORD: this.password,
                ID_ACCESS_ROLE: this.selectedAccess.ID_ACCESS_ROLE,
                IS_ACTIVED: this.isActived.value,
                CREATED_BY: this.currentUser.USERNAME,
                UPDATED_BY: this.currentUser.USERNAME
            }).then(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User created successfully' });
                this.ngOnInit();
            }).catch(() => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create user' });
            })
        }
        this.userDialog = false;
    }

    saveSections() {
        this.userService.editUser({
            USERNAME: this.username,
            LIST_SECTION: JSON.stringify(this.selectedSections),
            UPDATED_BY: this.currentUser.USERNAME
        }).then(() => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User updated successfully' });
            this.ngOnInit();
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update user' });
        })
        this.sectionDialog = false;
    }

    addUser() {
        this.openDialog('add');
    }

    removeUser(event: Event, data: any) {
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'If you delete this user, you will not be able to recover it and related data will be lost?',
            header: 'Delete User',
            icon: 'pi pi-info-circle',
            rejectLabel: 'Cancel',
            rejectButtonProps: {
                label: 'Cancel',
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: 'Delete',
                severity: 'danger',
            },

            accept: () => {
                const payload = {
                    USERNAME : data.USERNAME
                }
                this.userService.deleteUser(payload).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User deleted successfully' });
                    this.ngOnInit();
                }).catch(() => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete user' });
                })
            },
            reject: () => {
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
            },
        });
    }

    downloadExcelTemplate() {
        const wsData = [
            ['NO', 'FULLNAME', 'USERNAME', 'PASSWORD', 'IS_ACTIVED'],
            [1, 'Contoh Nama', 'contohuser', 'password123', 1]
        ];
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        ws['!cols'] = [{ wch: 5 }, { wch: 25 }, { wch: 20 }, { wch: 20 }, { wch: 15 }];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Template User');
        XLSX.writeFile(wb, 'template_user.xlsx');
        this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Template Excel berhasil didownload' });
    }

    async onExcelFileSelected(event: Event) {
        const fileInput = event.target as HTMLInputElement;
        const file = fileInput.files?.[0];
        if (!file) return;
        fileInput.value = '';

        const reader = new FileReader();
        reader.onload = async (e: any) => {
            try {
                const data = new Uint8Array(e.target.result);
                const wb = XLSX.read(data, { type: 'array' });
                const ws = wb.Sheets[wb.SheetNames[0]];
                const rows: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });

                // Hanya proses baris yang memiliki USERNAME (kolom index 2) yang valid
                const dataRows = rows.slice(1).filter((r: any[]) => {
                    const username = String(r[2] || '').trim();
                    const fullname = String(r[1] || '').trim();
                    return username !== '' && fullname !== '';
                });

                if (dataRows.length === 0) {
                    this.messageService.add({ severity: 'warn', summary: 'Peringatan', detail: 'File Excel tidak memiliki data.' });
                    return;
                }

                this.uploadTotal = dataRows.length;
                this.uploadCurrent = 0;
                this.uploadSuccess = 0;
                this.uploadFailed = 0;
                this.uploadResults = [];
                this.uploadProcessing = true;
                this.uploadProgressDialog = true;

                // Pastikan accessRoles sudah terisi, jika belum ambil dari API
                if (!this.accessRoles || this.accessRoles.length === 0) {
                    try {
                        const rolesRes = await this.userService.getAccessRoles();
                        this.accessRoles = rolesRes?.data || [];
                        this.setupRoleFilterOptions();
                    } catch (e) {
                        console.error('Failed to load access roles on upload', e);
                    }
                }

                // Auto-cari role Peserta dari accessRoles
                const pesertaRole = this.accessRoles.find((r: any) =>
                    r.NAME_ACCESS_ROLE?.toLowerCase().includes('peserta')
                );
                // ID_ACCESS_ROLE Peserta default: 'HAGSJ76H98'
                const autoRoleId = pesertaRole?.ID_ACCESS_ROLE || this.accessRoles[0]?.ID_ACCESS_ROLE || 'HAGSJ76H98';

                if (!autoRoleId) {
                    this.uploadProgressDialog = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Peran akses (Role) tidak ditemukan. Gagal memproses upload.' });
                    return;
                }

                for (let i = 0; i < dataRows.length; i++) {
                    const row = dataRows[i];
                    const username = String(row[2] || '').trim();
                    const fullname = String(row[1] || '').trim();
                    try {
                        await this.userService.registerUser({
                            FULLNAME: fullname,
                            USERNAME: username,
                            PASSWORD: String(row[3] || '').trim(),
                            ID_ACCESS_ROLE: autoRoleId,
                            IS_ACTIVED: Number(row[4] ?? 1),
                            CREATED_BY: this.currentUser?.USERNAME || 'system',
                            UPDATED_BY: this.currentUser?.USERNAME || 'system'
                        });
                        this.uploadSuccess++;
                        this.uploadResults.push({ row: i + 2, username, status: 'Berhasil' });
                    } catch (err: any) {
                        this.uploadFailed++;
                        const errMsg = (() => {
                            const m = err?.error?.message || err?.message;
                            if (!m) return 'Error tidak diketahui';
                            if (typeof m === 'string') return m;
                            return JSON.stringify(m);
                        })();
                        this.uploadResults.push({ row: i + 2, username, status: 'Gagal', error: errMsg });
                    }
                    this.uploadCurrent++;
                }

                this.uploadProcessing = false;
                this.uploadProgressDialog = false;
                this.uploadSummaryDialog = true;

            } catch {
                this.uploadProgressDialog = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal membaca file Excel. Pastikan format file benar.' });
            }
        };
        reader.readAsArrayBuffer(file);
    }

    closeSummaryAndRefresh() {
        this.uploadSummaryDialog = false;
        this.ngOnInit();
    }
}